<template>
  <WButton
    :class="[bgColor, textColor, buttonClasses]"
    :disabled="disabled">
    <div v-if="icon">
      <fa-icon
        :class="['mr-8', iconClasses]"
        :icon="icon"
        size="lg"
        :color="iconColor"
        class="align-middle">
      </fa-icon>
    </div>
    <div v-if="image">
      <img
        :class="['mr-8', iconClasses]"
        :src="image"
        alt="" />
    </div>
    <span class="w-full text-center">
      {{ label }}
    </span>
  </WButton>
</template>

<script>
import {
  defineComponent
} from "vue";

import WButton from "@/components/wrappers/WButton";
import FaIcon from "@/components/utils/FaIcon";

export default defineComponent({
  name: "IconButton",
  components: {
    WButton,
    FaIcon
  },
  props: {
    buttonClasses: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: false,
      default: "bg-dark-green"
    },
    textColor: {
      type: String,
      required: false,
      default: "text-white"
    },
    iconColor: {
      type: String,
      required: false,
      default: "text-white"
    },
    iconClasses: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    image: {
      type: String,
      required: false
    }
  }
});
</script>
